import React from 'react';

const ImageCropper = ({
  imageUrl,
  coordinates,
  dimensions,
}) => {
  if (!(dimensions.clientWidth && dimensions.clientHeight)) {
    return null;
  }
  const [top, left, width, height] = coordinates;
  const {clientWidth, clientHeight} = dimensions;
  const cropTop = -clientHeight * top/100;
  const cropLeft = -clientWidth * left/100;
  const cropWidth = clientWidth * width/100;
  const cropHeight = clientHeight * height/100;
  // The combination of maxWidth and viewBox give the svg element an intrinsic
  // size allowing it to be scaled with css in the usual manner
  return (
    <svg viewBox={`0 0 ${cropWidth} ${cropHeight}`}
      style={{maxWidth: `100%`, maxHeight: `400px`}}>
        <image href={imageUrl} x={cropLeft} y={cropTop} />
    </svg>
  )
};

export default ImageCropper;
